//maps database column names to the headers we expect from excel files

const AGMEditColumnNameMap = {
    "Site_Name": "Site Name",
    "Real_Chain": "Real Chain (km)",
    "Est_Chain": "Estimated Chain (km)",
    "Calc_Chain": "Calculated Chain (km)",
    "Verified": "Verified",
    "Est_Lat": "Estimated Latitude",
    "Est_Lng": "Estimated Longitude",
    "Planning_Notes": "Planning Notes",
    "Real_Chain_Delta": "Real Chain Delta",
    "Real_Lat": "Real Latitude",
    "Real_Lng": "Real Longitude",
    "GPS_Taken": "GPS Taken",
    "Site_Type": "Site Type",
    "Ref_Point": "Reference Point",
    "Dist_Ref_Point": "Dist Ref Point",
    "Site_Notes": "Site Notes",
    "Address": "Address",
    "Access_Notes": "Access Notes",
    "Chain_Quality": "Chain Quality",
    "Height": "Height",
    "Northing": "Northing",
    "Easting": "Easting",
    "Elevation": "Elevation",
    "Depth": "Depth",
    "Adj_Elevation": "Adj Elevation",
    "H_Perc": "H Perc",
    "V_Perc": "V Perc",
    "PDOP": "PDOP",
    "Obtime": "Obtime",
    "LSD": "LSD",
    "Surveyor": "Surveyor",
    "Survey_Date": "Survey Date"
  }

  const AGMPlanningColumnNameMap = {
    "Site_Name": "Site Name",
    // "Real_Chain": "Real Chain (km)",
    "Est_Chain": "Estimated Chain (km)",
    "Est_Lat": "Estimated Latitude",
    "Est_Lng": "Estimated Longitude",
    "Planning_Notes": "Planning Notes",
    "Address": "Address",
    "Access_Notes": "Access Notes"
  }

  const SubchainColumnNameMap = {
    "SC_Name": "Subchain",
    "OrderNum": "Order",
    "US_Site": "Upstream site",
    "DS_Site": "Downstream site",
    "Dist_To_US": "Distance to upstream",
    "Dist_To_DS": "Distance to downstream",
    "lat": "Latitude",
    "lng": "Longitude",
    "Elevation": "Elevation" 
  }

  const RunColumnNameMap = {
    "Run_Name": "Run Name",
    "Low_Speed": "Low Speed",
    "High_Speed": "High Speed",
    "IsActive": "Is Active",
  }

export {AGMEditColumnNameMap, AGMPlanningColumnNameMap, SubchainColumnNameMap, RunColumnNameMap}